import { Component, OnInit, Inject } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { AuthService } from "../../services/auth.service";
import { Globals } from '../../services/globals.service';
import { LeadService } from '../../services/lead.service';
import { ILeadHeader } from '../../interfaces/leadHeader';
import { PhonePipe } from '../../pipes/phone.pipe'
import { IFollowUp } from '../../interfaces/followup'
import { ISalesNote } from '../../interfaces/salesNote'
import { ICSGNote } from '../../interfaces/CSGNote'
import { Router } from "@angular/router";

@Component({
  selector: 'app-lead-grid',
  templateUrl: './lead-grid.component.html',
  styleUrls: ['./lead-grid.component.css'],
  providers: [PhonePipe]
})
export class LeadGridComponent implements OnInit {
  rows: ILeadHeader[];
  rowExpanded : any;
  rowOpen: number;
  selectedLead: any;
  leadData: any;
  cols: any[];
  displayEditFollowUp: boolean = false;
  displayEditSalesNote: boolean = false;
  displayEditCSGNote: boolean = false;
  newFollowUp: Date;
  newSalesNote: string;
  newCSGNote: string;
  iconStyles = {
    'width': this.auth.isAdministrator() ? '11em' : '3em'
  };

  constructor(private messageService: MessageService,
    private leadService: LeadService,
    private globals: Globals,
    public auth: AuthService,
    private router: Router,
    @Inject('BASE_URL') baseUrl: string) {

    leadService.getLeadHeaders()
      .subscribe(
        data => this.rows = data,
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error getting lead header', detail: err.error });
          console.log(err);
        }
      );
  }

  ngOnInit() {
    this.cols = [
      { field: "uldstat" },
      { field: "status" },
      { field: "company" },
      { field: "contact" },
      { field: "city" },
      { field: "state" }
    ]
  }

  onRowSelect(event) {
    console.log("Row selected" + event.data.uguid);
    this.messageService.add ({ severity: 'info', summary: 'Lead Selected', detail: 'Uguid: ' + event.data.uguid });
  }

  onRowUnselect(event) {
    console.log("Row unselected");
    this.messageService.add({ severity: 'success', summary: 'Lead Unselected', detail: 'Uguid: ' + event.data.uguid });
  }

  onRowExpand(rowe) {
    //console.log("row expand");
    //console.log(rowe);
    //console.log(rowe.data.lid);
    this.leadData = [];
    this.rowExpanded = rowe.data;
    this.leadService.getLead(rowe.data.lid)
      .subscribe(
        data => this.leadData = data,
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error getting lead', detail: err.error });
          console.log(err);
        }
      );
  }

  showEditFollowUp() {
    if (!this.leadData.std2.stdv.std.followup) {
      this.newFollowUp = new Date();
    } else {
      this.newFollowUp = new Date(this.leadData.std2.stdv.std.followup);
    }

    this.displayEditFollowUp = true;
  }

  showEditSalesNote() {
    let header: string = "Created by " + this.globals.user + ", " + new Date().toLocaleString() + "\n";
    this.newSalesNote = header;
    this.displayEditSalesNote = true;
  }

  showEditCSGNote() {
    let header: string = "Created by " + this.globals.user + ", " + new Date().toLocaleString() + "\n";
    this.newCSGNote = header;
    this.displayEditCSGNote = true;
  }

  updateFollowUp() {
    this.displayEditFollowUp = false;
    let fu: IFollowUp = { lid: this.leadData.std2.stdv.std.lid, followUp: this.newFollowUp };
    this.leadService.updateFollowUp(fu)
      .subscribe(
        data => {
          //console.log(data);
          this.leadData.std2.stdv.std.followup = data.followUp;
          this.messageService.add({ severity: 'success', summary: 'Follow up field was updated to:', detail: new Date(data.followUp).toLocaleDateString('en-US') });
        },
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error updating follow up field', detail: err.error });
          console.log(err);
        }
      );
  }

  updateSalesNote() {
    this.displayEditSalesNote = false;
    let sn: ISalesNote = {
      uguid: this.leadData.std2.stdv.std.uguid,
      salesNote: this.newSalesNote,
      modifiedDate : new Date()
    };
    this.leadService.updateSalesNote(sn)
      .subscribe(
        data => {
          //console.log(data);
          this.leadData.std2.salesNotes = data.salesNote;
          this.leadData.std2.stdv.std.modified = data.modifiedDate;
          let index = this.rows.indexOf(this.rowExpanded);
          if (index > -1) {
            this.rows[index].modified = data.modifiedDate.toString();
          }
          this.messageService.add({ severity: 'success', summary: 'Sales Note was updated to:', detail: this.newSalesNote });
        },
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error updating Sales Note field', detail: err.error });
          console.log(err.message);
        }
      );
  }

  updateCSGNote() {
    this.displayEditCSGNote = false;
    let cn: ICSGNote = {
      lid: this.leadData.std2.stdv.std.lid,
      csgNote: this.newCSGNote,
      modifiedDate: new Date()
    };
    this.leadService.updateCSGNote(cn)
      .subscribe(
        data => {
          this.leadData.std2.stdv.std.notes = data.csgNote;
          this.leadData.std2.stdv.std.modified = data.modifiedDate;
          let index = this.rows.indexOf(this.rowExpanded);
          if (index > -1) {
            this.rows[index].modified = data.modifiedDate.toString();
          }
          this.messageService.add({ severity: 'success', summary: 'CSG Note was updated to:', detail: this.newCSGNote });
        },
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error updating CSG Note field', detail: err.error });
          console.log(err.message);
        }
      );
  }

  emailLead(row) {
    //console.log(row); 
    this.leadService.emailSalesLead(row.lid)
      .subscribe(
        data => {
          //console.log(data);
          this.messageService.add({ severity: 'success', summary: 'Lead was emailed to Dawn', detail: data.contact + " @ " + data.company });
        },
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error emailing Sales Note', detail: err.error });
          console.log(err.message);
        }
      );
  }

  emailCSV() {
    //console.log(this.globals.cc);
    this.leadService.emailClientDatabase(this.globals.cc)
      .subscribe(
        data => {
          console.log(data);
          this.messageService.add({ severity: 'success', summary: 'Database in CSV format was emailed to Dawn', detail:  data.company });
        },
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error emailing Database', detail: err.error });
          console.log(err.message);
        }
      );
  }

  removeLead(row) {
    //console.log(row); 
    if (window.confirm('Are sure you want to delete this lead: ' + row.contact + " - " + row.company + "?")) {
      //alert("Delete Lid:" + row.lid.toString());
      this.leadService.deleteLead(row.lid)
        .subscribe(
          data => {
            //console.log(data);
            let index = this.rows.indexOf(row);
            this.rows = this.rows.filter((val, i) => i != index);
            //console.log(this.rows);
            this.messageService.add({ severity: 'success', summary: 'Lead was deleted', detail: row.contact + " @ " + row.company });
          },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Error deleting lead', detail: err.error });
            console.log(err.message);
          }
        );
    }
  }

  editLead(row) {
    //console.log(row);
    this.router.navigate(['/add-edit-lead', row.lid]);
    //if (window.confirm('Are sure you want to edit this item: ' + row.contact + " - " + row.company + "?")) {
    //  alert("Edit Lid:" + row.lid.toString());
    //  //edit logic
    //}
  }

}
